// extracted by mini-css-extract-plugin
var _1 = "ForgotView-module__animateUploadProgressBarWidth--EuH5W";
var _2 = "ForgotView-module__animatedBackground--kUetZ";
var _3 = "ForgotView-module__emailDescription--HKXno";
var _4 = "ForgotView-module__resetLinkButton--hMa6h";
var _5 = "ForgotView-module__successMessage--MYf0P";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "emailDescription", _4 as "resetLinkButton", _5 as "successMessage" }
